export const ProfilePhotoMimeTypes = [
  'image/gif',
  'image/jpeg',
  'image/pjpeg',
  'image/x-png',
  'image/png',
  'image/svg+xml'
];

export default ProfilePhotoMimeTypes;
